module.exports = __webpack_public_path__ + "static/img/led_difuso_verde_3mm-1.20bda92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_verde_3mm-1.svg
// module id = CWlZ
// module chunks = 0